import React, { useContext } from 'react'
import { ContentFooter } from '../../layout/Content'
import RecordNavigator from '../../layout/RecordNavigator'
import StockOutListFooterStyle from './css/StockOutListFooterStyle'
import { stockOutListControllerContext } from './StockOutListController'

function StockOutListFooter() {
  const stockOutListController = useContext(stockOutListControllerContext)
  const { getTotalRecords, totalPage, warehouses } = stockOutListController
  const [recordPerPage, setRecordPerPage] = stockOutListController.recordPerPage
  const [recPP, setRecPP] = stockOutListController.recPP
  const [page, setPage] = stockOutListController.page
  const [warehouse, setWarehouse] = stockOutListController.warehouse

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    totalPage, getTotalRecords
  }

  const onChange = (e) => {
    let warehouse_id = (warehouses.find(wh => wh.name === e.target.value)._id)
    if (!warehouse_id) warehouse_id = 0
     setWarehouse({
      ...warehouse,
      name: e.target.value,
      _id: warehouse_id
    })
  }

  return (
    <ContentFooter>
      <div id="stockout-list-footer-container">
        <div className='warehouse-options-container'>
          <select
            onChange={onChange}
            value={(warehouse) ? warehouse.name : ''}>
            {
              (warehouses) ?
                warehouses.map(wh => (
                  <option key={wh._id}>{wh.name}</option>
                ))
              : null
            }
          </select>
        </div>
        <RecordNavigator { ...recordNavigatorProps } />
      </div>
      <StockOutListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(StockOutListFooter)
